import React from 'react'

interface PoorIconProps {
  width?: number
  height?: number
}

const PoorIcon: React.FC<PoorIconProps> = ({ width = 84, height = 45 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 84 45" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-outside-1_3566_6660" maskUnits="userSpaceOnUse" x="0" y="0" width="84" height="44" fill="black">
        <rect fill="white" width="84" height="44" />
        <path d="M82 42C82 31.3913 77.7856 21.2173 70.2842 13.7158C62.7827 6.21436 52.6087 2 42 2C31.3913 2 21.2173 6.21436 13.7158 13.7158C6.21437 21.2173 2 31.3913 2 42H18C18 28.7452 28.7452 18 42 18C55.2548 18 66 28.7452 66 42H82Z" />
      </mask>
      <path
        d="M82 42C82 31.3913 77.7856 21.2173 70.2842 13.7158C62.7827 6.21436 52.6087 2 42 2C31.3913 2 21.2173 6.21436 13.7158 13.7158C6.21437 21.2173 2 31.3913 2 42H18C18 28.7452 28.7452 18 42 18C55.2548 18 66 28.7452 66 42H82Z"
        fill="#E0E0E0"
      />
      <path
        d="M82 42H84V44H82V42ZM70.2842 13.7158L68.87 15.13L70.2842 13.7158ZM42 2V0V2ZM13.7158 13.7158L15.13 15.13L13.7158 13.7158ZM2 42V44H-2.38419e-07L0 42L2 42ZM18 42H20V44H18V42ZM66 42V44H64V42H66ZM82 42H80C80 31.9218 75.9964 22.2564 68.87 15.13L70.2842 13.7158L71.6984 12.3016C79.5749 20.1781 84 30.8609 84 42H82ZM70.2842 13.7158L68.87 15.13C61.7436 8.00364 52.0782 4 42 4V2V0C53.1391 0 63.8219 4.42509 71.6984 12.3016L70.2842 13.7158ZM42 2V4C31.9218 4 22.2564 8.00364 15.13 15.13L13.7158 13.7158L12.3016 12.3016C20.1781 4.42509 30.8609 0 42 0V2ZM13.7158 13.7158L15.13 15.13C8.00364 22.2564 4 31.9218 4 42L2 42L0 42C1.66893e-06 30.8609 4.42509 20.1781 12.3016 12.3016L13.7158 13.7158ZM2 42V40H18V42V44H2V42ZM18 42H16C16 27.6406 27.6406 16 42 16V18V20C29.8497 20 20 29.8497 20 42H18ZM42 18V16C56.3594 16 68 27.6406 68 42H66H64C64 29.8497 54.1503 20 42 20V18ZM66 42V40H82V42V44H66V42Z"
        fill="white"
        mask="url(#path-1-outside-1_3566_6660)"
      />
      <mask
        id="path-3-outside-2_3566_6660"
        maskUnits="userSpaceOnUse"
        x="0"
        y="3.99414"
        width="33"
        height="41"
        fill="black"
      >
        <rect fill="white" y="3.99414" width="33" height="41" />
        <path d="M18 42.0146C18 42.0098 18 42.0049 18 42C18 33.2128 22.7232 25.5304 29.7686 21.3486L21.6162 7.58301C15.6359 11.1249 10.682 16.1645 7.24219 22.2041C3.80242 28.2436 1.99559 35.075 2 42.0254L18 42.0146Z" />
      </mask>
      <path
        d="M18 42.0146C18 42.0098 18 42.0049 18 42C18 33.2128 22.7232 25.5304 29.7686 21.3486L21.6162 7.58301C15.6359 11.1249 10.682 16.1645 7.24219 22.2041C3.80242 28.2436 1.99559 35.075 2 42.0254L18 42.0146Z"
        fill="#FA7A5D"
      />
      <path
        d="M18 42.0146L20 42.0135L20.0012 44.0133L18.0013 44.0146L18 42.0146ZM29.7686 21.3486L31.4894 20.3295L32.5076 22.0487L30.7894 23.0685L29.7686 21.3486ZM21.6162 7.58301L20.597 5.86217L22.3179 4.84296L23.3371 6.56387L21.6162 7.58301ZM7.24219 22.2041L5.50429 21.2143L5.50429 21.2143L7.24219 22.2041ZM2 42.0254L2.00134 44.0254L0.00126994 44.0267L3.57628e-07 42.0267L2 42.0254ZM18 42.0146L16 42.0158C16 42.0103 16 42.0032 16 42H18H20C20 42.0066 20 42.0093 20 42.0135L18 42.0146ZM18 42H16C16 32.4778 21.1208 24.1557 28.7477 19.6288L29.7686 21.3486L30.7894 23.0685C24.3256 26.905 20 33.9478 20 42H18ZM29.7686 21.3486L28.0477 22.3678L19.8953 8.60214L21.6162 7.58301L23.3371 6.56387L31.4894 20.3295L29.7686 21.3486ZM21.6162 7.58301L22.6354 9.30384C16.9542 12.6686 12.248 17.4562 8.98008 23.1939L7.24219 22.2041L5.50429 21.2143C9.11603 14.8728 14.3176 9.58121 20.597 5.86217L21.6162 7.58301ZM7.24219 22.2041L8.98008 23.1939C5.71229 28.9315 3.99581 35.4213 4 42.0241L2 42.0254L3.57628e-07 42.0267C-0.00463223 34.7287 1.89255 27.5558 5.50429 21.2143L7.24219 22.2041ZM2 42.0254L1.99866 40.0254L17.9987 40.0146L18 42.0146L18.0013 44.0146L2.00134 44.0254L2 42.0254Z"
        fill="white"
        mask="url(#path-3-outside-2_3566_6660)"
      />
    </svg>
  )
}

export default PoorIcon
